import { PARTNER_TYPES } from '../../partner-types';
import { MenuItem } from '../types';

export const marketingSection: MenuItem[] = [
  {
    headTitle1: 'ryd Marketing',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
  },
  {
    path: '/ryd-marketing/overview',
    title: 'Overview',
    icon: 'stroke-home',
    iconf: 'fill-home',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
  },
  {
    title: 'Deeplinking',
    icon: 'stroke-deeplinking',
    iconf: 'fill-deeplinking',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/ryd-marketing/deeplinking/add-dynamic-parameters',
        title: 'Add Dynamic Parameters',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
    ],
  },
  {
    title: 'CDN Management',
    icon: 'stroke-cdn-management',
    iconf: 'fill-cdn-management',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/ryd-marketing/cdn-management/cdn-file-management',
        title: 'CDN File Management',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
    ],
  },
  {
    title: 'Discount Campaigns',
    icon: 'stroke-landing-page',
    iconf: 'fill-landing-page',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/voucher-campaigns/statistics',
        title: 'Landing Page Statistics',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/voucher-campaigns/order-statistics',
        title: 'Order Statistics',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/voucher-campaigns/registrations',
        title: 'Campaign Registrations',
        type: 'link',
        active: false,
        // The single-customer page (`…/registrations/<row id>`) has no menu
        // entry; it keeps this one highlighted. Declared here as well as in the
        // partner's own section — ryd staff reach the same pages from here.
        activePathPrefixes: ['/voucher-campaigns/registrations/*'],
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/voucher-campaigns/how-it-works',
        title: 'How It Works',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
    ],
  },
  {
    title: 'Mandrill Templates',
    icon: 'stroke-email',
    iconf: 'fill-email',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/ryd-marketing/mandrill-templates/template-browser',
        title: 'Template Browser',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/ryd-marketing/mandrill-templates/template-usage-analytics',
        title: 'Template usage analytics',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
    ],
  },
  {
    title: 'Marketing Automation',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/ryd-marketing/mailchimp-audience-export',
        title: 'Mailchimp Audience Export',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/ryd-marketing/mailchimp-audience-export/knowledge-base',
        title: 'Mailchimp Export KB',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: ['mailchimp', 'audience export', 'merge fields', 'ttp', 'knowledge base'],
      },
    ],
  },
  {
    title: 'Pitch Builder',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/ryd-marketing/pitch-builder',
        title: 'Pitch Builder',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: ['pitch', 'deck', 'presentation', 'slides', 'sales'],
      },
      {
        path: '/ryd-marketing/pitch-builder/saved',
        title: 'Saved Pitches',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: ['pitch', 'saved', 'library', 'decks', 'presentations'],
      },
      {
        path: '/ryd-marketing/pitch-builder/knowledge-base',
        title: 'Knowledge Base',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: [
          'pitch builder guide',
          'knowledge base',
          'claude artifact',
          'import pitch builder',
        ],
      },
      {
        path: '/ryd-marketing/pitch-builder/admin',
        title: 'Pitch Builder Metadata',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: ['pitch builder admin', 'metadata', 'stats'],
      },
    ],
  },
  {
    title: 'Homepage',
    icon: 'stroke-homepage',
    iconf: 'fill-homepage',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/ryd-marketing/homepage/partner-affiliate-links',
        title: 'Partner Affiliate Links',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/ryd-marketing/homepage/awin-pushes',
        title: 'Awin Pushes',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
];
